import axios from "@/libs/api.request.js";
import { getSyEnv } from "@/apis/gameJump";

/**
 * 账号注销相关接口
 *
 * 接口契约见《账户注销申请流程与接口文档》：
 * 所有接口均为 JSON 请求体（axios 默认 post + 对象即 JSON）。
 * closeToken 作为业务参数放在 body 中传给 /user/close/apply，
 * 不是 localStorage 里的正式登录 token，故不使用 requireToken。
 */

// 账号密码登录 { user_name, password }
export const loginByPasswordApi = (data) =>
  axios.request({ baseURL: getSyEnv(), url: "/user/close/login/password", data });

// 发送登录验证码 { tel_num }
export const sendLoginSmsApi = (data) =>
  axios.request({ baseURL: getSyEnv(), url: "/user/close/login/sms-code", data });

// 短信验证码登录 { tel_num, code }
export const loginBySmsApi = (data) =>
  axios.request({ baseURL: getSyEnv(), url: "/user/close/login/sms", data });

// 提交注销申请
// { close_token, user_id, user_name, reason_type, reason?, id_card_name, id_card_num }
export const submitCancelApi = (data) =>
  axios.request({ baseURL: getSyEnv(), url: "/user/close/apply", data });
